
const LoadingScreen = () => (
  <div className="flex justify-center items-center h-screen bg-white">
    <div className="flex space-x-2">
      <div className="w-4 h-4 bg-green-600 rounded-full animate-bounce" />
      <div className="w-4 h-4 bg-green-600 rounded-full animate-bounce delay-200" />
      <div className="w-4 h-4 bg-green-600 rounded-full animate-bounce delay-400" />
    </div>
  </div>
);

export default LoadingScreen;
